import { useLocation } from "wouter";

/**
 * Keep route changes behind a small app-level hook so presentational pages do
 * not need to couple their markup directly to the router implementation.
 */
export function useAppNavigation(): (destination: string) => void {
  const [, navigate] = useLocation();
  return navigate;
}
